
  export default {
    props: {
      organization: {
        type: Object,
        require: true,
        default: () => {},
      },
    },
    data() {
      return {
        industries: [],
        activities: [],
        titles: [],
      };
    },
    created() {
      this.industries = this.organization.industries.split(',');
      this.activities = this.organization.activities.split(',');
      let titles = [];

      if (this.industries.length > 1 && this.activities.length <= 1) {
        titles = this.industries;
      } else if (this.industries.length <= 1 && this.activities.length > 1) {
        titles = this.activities;
      } else if (this.industries.length <= 1 && this.activities.length <= 1) {
        titles = [];
      } else {
        titles = [].concat.apply(
          this.industries ? this.industries : [],
          this.activities ? this.activities : []
        );
      }
      this.titles = titles.filter((val) => val && true && true && val !== ' ');
    },
  };
